
<canvas class="canvas-chart" baseChart [options]="props.graphicOptions" [datasets]="lineChartData" [labels]="lineChartLabels" [legend]="lineChartLegend" [type]="props.typeGraphic"></canvas>
